import { TWO_FACTOR_ERROR_CODES, type TwoFactorErrorCode } from '../../app/modules/types/twoFactor'

/** A two-factor API failure: the UI branches on `code` (and `status` for the rate limit). */
export interface TwoFactorFailure {
  status: number | null
  code: TwoFactorErrorCode | null
}

const CODES: ReadonlySet<string> = new Set(TWO_FACTOR_ERROR_CODES)

export function readTwoFactorError(error: unknown): TwoFactorFailure {
  const response = (error as { response?: { status?: number; data?: unknown } } | null)?.response
  const data = response?.data
  const raw = data && typeof data === 'object' ? (data as { code?: unknown }).code : undefined
  return {
    status: response?.status ?? null,
    code: typeof raw === 'string' && CODES.has(raw) ? (raw as TwoFactorErrorCode) : null,
  }
}

export const isRateLimited = (failure: TwoFactorFailure): boolean => failure.status === 429
